import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../core/auth/auth.service';


@Component({
  selector: 'hb-reporting-role-notification',
  templateUrl: './reporting-role-notification.component.html',
})
export class ReportingRoleNotificationComponent implements OnInit , OnDestroy{
  public label: string = 'Login';
  private unsubscribe: Subject<boolean> = new Subject();

  constructor(public router: Router, public authService: AuthService) {}

  ngOnInit() {
    this.authService.hideSpinner();
    this.authService.loggedIn.pipe(takeUntil(this.unsubscribe)).subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.label = 'Ok';
      }
    });
  }
  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

}
